var _style, _g, _g2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgLogoWhite(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "-261 384.2 87.4 25.8",
    style: {
      enableBackground: "new -261 384.2 87.4 25.8"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\r\r\n\t.st0{fill:#FFFFFF;}\r\r\n")), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "XMLID_33_"
  }, /*#__PURE__*/React.createElement("polygon", {
    id: "XMLID_1_",
    className: "st0",
    points: "-246.7,392.8 -245.2,389.1 -237.1,408.5 -240,408.5 -242.4,402.8 -250.8,402.8  -249.7,400.3 -243.6,400.3  "
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "XMLID_2_",
    className: "st0",
    points: "-244.2,405.8 -243.2,408.5 -259,408.5 -249.5,385.6 -246.4,385.6 -254.7,405.8  "
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    id: "XMLID_39_"
  }, /*#__PURE__*/React.createElement("g", {
    id: "XMLID_198_"
  }, /*#__PURE__*/React.createElement("path", {
    id: "XMLID_208_",
    className: "st0",
    d: "M-230,404.1v-14h1.6v12.6h6.2v1.5h-7.8V404.1z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_206_",
    className: "st0",
    d: "M-209.4,390.1v9.1c0,1.6-0.5,2.9-1.5,3.8c-1,0.9-2.3,1.4-4,1.4c-1.7,0-3-0.5-3.9-1.4 c-0.9-0.9-1.4-2.2-1.4-3.8v-9.1h1.6v9.1c0,1.2,0.3,2.1,1,2.7c0.6,0.6,1.6,0.9,2.8,0.9s2.1-0.3,2.7-0.9c0.6-0.6,1-1.5,1-2.7v-9.1 H-209.4z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_204_",
    className: "st0",
    d: "M-199.6,391.3c-1.5,0-2.8,0.5-3.7,1.5c-0.9,1-1.3,2.4-1.3,4.2c0,1.8,0.4,3.3,1.3,4.3 c0.9,1,2.1,1.5,3.7,1.5c1,0,2.1-0.2,3.4-0.5v1.4c-1,0.4-2.2,0.5-3.6,0.5c-2.1,0-3.7-0.6-4.8-1.9c-1.1-1.3-1.7-3-1.7-5.4 c0-1.4,0.3-2.7,0.8-3.8c0.5-0.9,1.3-1.8,2.3-2.4s2.2-0.9,3.6-0.9c1.5,0,2.8,0.3,3.9,0.8l-0.7,1.4 C-197.5,391.6-198.6,391.3-199.6,391.3z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_202_",
    className: "st0",
    d: "M-193.2,404.1v-14h1.6v14.1h-1.6V404.1z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_199_",
    className: "st0",
    d: "M-176.5,396.9c0,2.3-0.6,4.1-1.9,5.3c-1.3,1.2-3.1,1.8-5.4,1.8h-3.9v-13.9h4.3 c2.2,0,3.9,0.6,5.1,1.8C-177.1,393.1-176.5,394.8-176.5,396.9z M-178.2,397c0-1.8-0.5-3.2-1.4-4.1c-0.9-0.9-2.3-1.4-4.1-1.4h-2.4 v11.2h2c1.9,0,3.4-0.5,4.4-1.4S-178.2,398.9-178.2,397z"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogoWhite);
export default __webpack_public_path__ + "static/media/logo-white.52826caf0f3fe5896bcde33e509104d1.svg";
export { ForwardRef as ReactComponent };